import { useCallback, useState } from "react";
import { NicheSelector } from "@/components/popups/NicheSelector";
import { updateNiches } from "./utils";
import { useData } from "./hooks";
import { Loader } from "@/components/UI/Loader";
import { IEditNichesDialogProps } from "@/common/buses/popups/popup-types";
import { onCloseEditGifNichesPopup } from "@/components/popup-dispatcher/PopupDispatcher";
import { Popup } from "@/components/popups/Popup";
import { Button } from "@/components/buttons/Button";
import "./EditNichesDialog.scss";

export const EditNichesDialog = ({ gifId, role }: IEditNichesDialogProps) => {
  const [selected, setSelected] = useState<string[]>();

  const { gif, niches, isLoading, isError } = useData({ gifId, role });

  const handleChange = useCallback((ids: string[]): void => {
    setSelected(ids);
  }, []);

  const handleClose = useCallback(() => {
    onCloseEditGifNichesPopup();
  }, []);

  const handleSave = useCallback(async () => {
    if (!selected) {
      handleClose();
      return;
    }

    const unselectedIds = niches
      .filter((niche => !selected.includes(niche.id)))
      .map(niche => niche.id);

    await updateNiches(gifId, unselectedIds, handleClose);
  }, [selected, gifId, handleClose]);

  return (
    <Popup
      isOpen={true}
      onClose={handleClose}
      title="Change gif niches"
      popupClass="editNichesPopup"
    >
      <NicheSelector
        niches={niches}
        selected={selected || gif?.niches || []}
        onChange={handleChange}
      />

      <div className="EditNicheBottom">
        <button className="EditNicheBottom-Cancel" onClick={handleClose}>Cancel</button>
        <Button onClick={handleSave}>Save</Button>
      </div>

      {
        isLoading && <Loader/>
      }

      {
        isError && <div>Could not get niches, please try again.</div>
      }
    </Popup>
  );
};
